var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"ctree-loading-icon__circle",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5","stroke-miterlimit":"10"}})])}
var staticRenderFns = []

export { render, staticRenderFns }